import propTypes from "prop-types";
import { Tooltip, Typography, useTheme } from "@mui/material";
import { cloneElement, useEffect, useState } from "react";
import { StarFilledIcon, StarOutlineIcon } from "src/components/icons/ResultIcons";
import { useNavigate } from "react-router-dom";
import AuthAccess from "src/data/auth/authAccess/AuthAccess";
import { StyledButton } from "src/components/styled/StyledButton";

export default function Koti_NavContainer({
  icon = null,
  title = "",
  desc = "",
  isStarred = false,
  setStarred = () => {},
  size = "medium", // small, medium, large, wide
  page = "common",
}) {
  const [star, setStar] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();
  // const paperColor = theme.palette.background.paper;

  const url = "/" + page;

  useEffect(() => {
    setStar(isStarred);
  }, [isStarred]);

  const handleStarClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setStar(!star);
    setStarred(url);
  };

  let height = size === "large" ? "150px" : size === "small" ? "100px" : "140px";
  // const width = size === "large" ? "250px" : size === "small" ? "150px" : "200px";
  let width = size === "large" ? "160px" : size === "small" ? "100px" : "135px";
  if (size === "wide") {
    width = "250px";
    height = "100px";
  }
  const iconSize = size === "large" ? "4em" : size === "small" ? "2em" : "3em";
  const titleFontSize = size === "large" ? "1.3em" : size === "small" ? "1em" : "1.15em";
  const descFontSize = size === "large" ? "1em" : size === "small" ? "0.8em" : "0.9em";

  return (
    <AuthAccess page={page}>
      <StyledButton
        variant="outlined"
        height={height}
        width={width}
        onClick={() => navigate(url)}
        disableLetterSpacing>
        <div style={{ position: "absolute", top: 0, right: 0 }} onClick={handleStarClick}>
          <Tooltip disableInteractive title={star ? "Oletus sivu" : "Aseta oletussivuksi"}>
            <div>
              {star ? (
                <StarFilledIcon sx={{ color: "yellow", fontSize: "2.3em" }} />
              ) : (
                <StarOutlineIcon sx={{ fontSize: "2.3em" }} />
              )}
            </div>
          </Tooltip>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            height: "100%",
          }}>
          {icon && cloneElement(icon, { style: { fontSize: iconSize } })}
          <Typography color="primary" sx={{ fontSize: titleFontSize }}>
            {title}
          </Typography>
          <Typography color="primary" sx={{ fontSize: descFontSize }}>
            {desc}
          </Typography>
        </div>
      </StyledButton>
    </AuthAccess>
  );
}

Koti_NavContainer.propTypes = {
  icon: propTypes.element,
  title: propTypes.string,
  page: propTypes.string,
  isStarred: propTypes.bool,
  setStarred: propTypes.func,
  desc: propTypes.string,
  size: propTypes.string,
};
